import classes from "./AdTab.module.scss";
import { AdTabProps } from "./config/tab";

const AdTab = ({ link, label }: AdTabProps) => {
  return (
    <a className={classes.adTab} href={link}>{label}</a>
  );
};

export default AdTab;
